import { ErrorHandler, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/browser';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly router = inject(Router);

  handleError(error: Error): void {
    console.error('Global error caught:', error);

    // Log to external error tracking service if configured
    this.logErrorToService(error);

    // Navigate to error page
    this.router.navigate(['/error'], {
      queryParams: { message: this.getErrorMessage(error) },
    });
  }

  private getErrorMessage(error: Error): string {
    if (error?.message) {
      return error.message;
    }
    return 'An unexpected error occurred';
  }

  private logErrorToService(error: Error): void {
    // Angular routes everything through its own ErrorHandler, so the SDK's
    // globalHandlers integration never sees these — they have to be captured
    // explicitly. Sentry.init() is a no-op when the DSN is empty, and
    // captureException on an uninitialised client is safely ignored.
    Sentry.captureException(error);
  }
}
